import { useKeycloak } from '@react-keycloak/web';
import React, { createContext, useContext, useEffect } from 'react';

import { TOKEN_SESSION_KEY } from 'features/Auth/CONSTANTS';

import { saveState } from 'Utilities/LocalStorage';

interface IAuthorizedCtx {
	hasAccessTo: (action: string | Array<string>) => boolean;
}
const AuthorizedContext = createContext<IAuthorizedCtx>({} as IAuthorizedCtx);

const { Provider } = AuthorizedContext;

export const PermissionProvider: React.FC = ({ children }) => {
	const { keycloak } = useKeycloak();
	useEffect(() => {
		if (keycloak) saveState(TOKEN_SESSION_KEY, keycloak.token);
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [keycloak.refreshToken]);

	const hasAccessTo = (action: string | Array<string>): boolean => {
		const SwipeKycPermissions = keycloak?.tokenParsed?.resource_access?.['swipe-kyc-ui']?.roles || [];
		const kycUiPermissions = keycloak?.tokenParsed?.resource_access?.['kyc-ui']?.roles || [];
		const permissions = [...SwipeKycPermissions, ...kycUiPermissions];
		//console.log('=======permissions======', permissions);
		if (!permissions) return false;
		if (!Array.isArray(permissions)) return false;
		if (Array.isArray(action)) {
			return permissions.some((permission) => action.some((a) => permission === a));
		}
		return permissions.some((permission) => permission === action);
	};

	return <Provider value={{ hasAccessTo }}>{children}</Provider>;
};

export default AuthorizedContext;

export const useHasAccessTo = (): ((action: string | Array<string>) => boolean) => {
	const { hasAccessTo } = useContext(AuthorizedContext);
	return (action: string | Array<string>): boolean => hasAccessTo(action);
};
